export const AI_ASSIST = "aiAssist";
export type AI_ASSIST = typeof AI_ASSIST;

export type AiAssistStateType = {
	/**
	 * Bumped per graphic an AI write touched. `GraphicDetails` rebuilds its edit buffer on this
	 * and nothing else, so a write behind the operator's back shows without losing keystrokes.
	 */
	writes: Record<string, number>;
};
